module.exports = __webpack_public_path__ + "static/media/p3s1.186fc949.jpg";